import React from 'react';
import * as MUI from '@material-ui/core';
import { useStyles } from './styles';

export const GlobalCategoryBody = ({ children, ...props }) => {
  const classes = useStyles(props);

  return (
    <MUI.AccordionDetails className={classes.globalCategoryBody}>
      {children}
    </MUI.AccordionDetails>
  );
}

export default GlobalCategoryBody;